<template>
  <Notifiche10Giorni
    :follow-up-days="40"
    page-title="Notifiche 40 giorni"
    page-subtitle="Check non compilati dopo 40 giorni, esclusi percorsi già gestiti o con attività successive."
  />
</template>

<script>
import Notifiche10Giorni from './Notifiche10Giorni.vue';

export default {
  name: 'Notifiche40Giorni',
  components: {
    Notifiche10Giorni,
  },
};
</script>
